import React, {useRef, useCallback} from 'react';

function useLongPress(onLongPress, onClick, delay = 500) {
    const timerRef = useRef(null);
    const firedRef = useRef(false);

    const start = useCallback(() => {
        firedRef.current = false;
        timerRef.current = setTimeout(() => {
            firedRef.current = true;
            onLongPress();
        }, delay);
    }, [onLongPress, delay]);

    const cancel = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    }, []);

    const handleClick = useCallback((e) => {
        if (firedRef.current) {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
        onClick();
    }, [onClick]);

    return {
        onMouseDown: start,
        onMouseUp: cancel,
        onMouseLeave: cancel,
        onTouchStart: start,
        onTouchEnd: cancel,
        onClick: handleClick,
        onContextMenu: (e) => e.preventDefault(),
        style: { touchAction: 'manipulation', userSelect: 'none', WebkitUserSelect: 'none' },
    };
}

function Sumthin({sumthin, onClick, onLongPress}){
    const handlers = useLongPress(
        () => onLongPress(sumthin),
        () => onClick(sumthin),
    );
    return(
        <div key={sumthin} className="sumthin">
            <span {...handlers} style={handlers.style}>{sumthin}</span>
        </div>
    )
}

function Suggested({sumthin, onClick, onLongPress}){
    const handlers = useLongPress(
        () => onLongPress(sumthin),
        () => onClick(sumthin),
    );
    return(
        <div key={sumthin} className="suggested">
            <span {...handlers} style={handlers.style}>{sumthin}</span>
        </div>
    )
}


export default function Sumthins({name, sumthins, suggested, liClick, sClick, liLongPress, sLongPress, hidden}){
    const listStyle = hidden ?
        { display: 'none' }
        : {width: '100%' }
    const  items = sumthins.map(sumthin =>
        <Sumthin sumthin={sumthin} onClick={liClick} onLongPress={liLongPress}></Sumthin>
    );
    const suggestions = suggested.map(sumthin =>
          <Suggested sumthin={sumthin} onClick={sClick} onLongPress={sLongPress}></Suggested>
     );
    return <div style={listStyle} className='sumthins'>
            {items}
            <br></br>
            {suggestions}
    </div>;
}


